import React from "react";

const TECHNIQUES = [
  {
    id: "pbr",
    name: "PBR",
  },
  {
    id: "hatching",
    name: "HATCHING",
  },
  {
    id: "toon",
    name: "TOON",
  },
  {
    id: "gooch",
    name: "GOOCH",
  },
  {
    id: "halftone",
    name: "HALFTONE",
  },
  {
    id: "outline",
    name: "EDGE",
  },
];

export default function TechniqueSelector({
  technique,
  setTechnique,
  setMode,
}) {
  function selectTechnique(id) {
    setTechnique(id);

    setMode("render");
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "6px",
      }}
    >
      {TECHNIQUES.map((option) => (
        <button
          key={option.id}
          type="button"

          className={
            technique === option.id
              ? "reconstruction-button active"
              : "reconstruction-button"
          }

          onClick={() => selectTechnique(option.id)}
        >
          {option.name}
        </button>
      ))}
    </div>
  );
}

export { TECHNIQUES };
